import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { toCssModifier } from '../../helpers/utils'

import { sendHoverSoundCommand, sendClickSoundCommand } from '../../helpers/web_to_client'

import { KEY_CODES } from '../../constants'

import styles from './Input.css'

export default class Input extends React.PureComponent {
    static propTypes = {
        type: PropTypes.oneOf(['text', 'search', 'password']),
        size: PropTypes.oneOf(['default', 'big', 'large']),
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        placeholder: PropTypes.node,
        isDisabled: PropTypes.bool,
        isFocusOn: PropTypes.bool,
        isSecure: PropTypes.bool,
        maxLength: PropTypes.number,

        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        onEnterPressed: PropTypes.func,
        onClearClick: PropTypes.func,
        tooltipId: PropTypes.string,
    }

    static defaultProps = {
        type: 'text',
        size: 'default',
    }

    constructor(props) {
        super(props)

        this.state = {
            isFocused: false,
        }
    }

    componentDidMount() {
        if (this.props.isFocusOn) {
            this._input.focus()
        }
    }

    setFocused(isFocused) {
        if (isFocused !== this.state.isFocused) {
            this.setState({
                isFocused,
            }, () => {
                if (isFocused) {
                    this._input.focus()
                }
            })
        }

        if (isFocused && this.props.onFocus) this.props.onFocus()
        if (!isFocused && this.props.onBlur) this.props.onBlur()
    }

    handleChange = (value) => {
        this.props.onChange(value.target.value)
    }

    handleClear = () => {
        this.props.onChange('')
        this.setFocused(true)
        if (this.props.onClearClick) this.props.onClearClick()
    }

    handleKeyDown = (event) => {
        if (this.props.onEnterPressed && event.keyCode === KEY_CODES.ENTER) {
            this.props.onEnterPressed()
        }
    }

    renderSearchIcon() {
        return this.props.type === 'search' ? (
            <div className={styles.searchIco} />
        ) : null
    }

    renderSecureIcon() {
        return this.props.isSecure ? (
            <div className={styles.secureIco} />
        ) : null
    }

    renderSearchClear() {
        return this.props.type === 'search' && this.props.value ? (
            <div
                className={styles.searchClear}
                onMouseDown={sendClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
                onClick={this.handleClear}
            />
        ) : null
    }

    renderPlaceholder() {
        return !this.state.isFocused && !!this.props.placeholder && !this.props.value ? (
            <div className={styles.placeholder}>{this.props.placeholder}</div>
        ) : null
    }

    render() {
        const classNameBase = classNames(
            styles.base,
            styles[`base__size${toCssModifier(this.props.size)}`],
            styles[`base__type${toCssModifier(this.props.type)}`],
            {
                [styles['base__focused']]: this.state.isFocused,
                [styles['base__disabled']]: this.props.isDisabled,
                [styles['base__secure']]: this.props.isSecure,
            },
        )

        const dataAttrs = this.props.tooltipId && !this.state.isFocused ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        return (
            <div className={classNameBase} {...dataAttrs}>
                {this.renderPlaceholder()}

                <div className={styles.inputWrapper}>
                    <input
                        maxLength={this.props.maxLength}
                        ref={c => (this._input = c)}
                        className={styles.input}
                        value={this.props.value}
                        disabled={this.props.isDisabled}
                        onChange={this.props.isDisabled ? null : this.handleChange}
                        onFocus={() => this.setFocused(true)}
                        onBlur={() => this.setFocused(false)}
                        onKeyDown={this.handleKeyDown}
                        type={this.props.type}
                    />
                </div>

                {this.renderSearchIcon()}
                {this.renderSearchClear()}
                {this.renderSecureIcon()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Input/Input.jsx